// src/utils/ocrComprobante.js
// OCR liviano + normalización para detectar texto de comprobantes

export const normalizeOCR = (s = "") =>
  s
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // sin tildes
    .replace(/[^\p{L}\p{N}\s:$%.-]/gu, " ") // limpia raro
    .replace(/\s+/g, " ")
    .trim();

export const scoreTransferText = (rawText = "") => {
  const text = normalizeOCR(rawText);

  // Palabras “fuertes” (si aparecen, es muy probable que sea comprobante)
  const strong = [
    "comprobante",
    "transferencia",
    "transferencia realizada",
    "operacion",
    "numero de operacion",
    "folio",
    "banco",
    "cuenta",
    "cuenta vista",
    "rut",
    "destinatario",
    "beneficiario",
    "monto",
    "fecha",
    "hora",
    "clp",
    "$",
    "mercado pago",
  ];

  // Palabras “suaves” (suman pero no bastan solas)
  const soft = [
    "pagado",
    "saldo",
    "abono",
    "envio",
    "exitosa",
    "confirmacion",
    "comision",
    "referencia",
    "id",
    "transaccion",
  ];

  let strongHits = 0;
  let softHits = 0;

  for (const k of strong) if (text.includes(k)) strongHits++;
  for (const k of soft) if (text.includes(k)) softHits++;

  // Reglas rápidas extra: presencia de monto “tipo” y/o rut
  const hasMoney =
    /\$\s?\d{1,3}(\.\d{3})+/.test(text) || // $14.000
    /\bclp\s?\d+/.test(text) ||
    /\bmonto\s?:?\s?\$?\s?\d+/.test(text);

  const hasRUT = /\b\d{1,2}\.?\d{3}\.?\d{3}-[\dk]\b/.test(text);

  const score =
    strongHits * 3 +
    softHits * 1 +
    (hasMoney ? 3 : 0) +
    (hasRUT ? 2 : 0);

  // Umbral sugerido:
  // - >= 8: probable comprobante
  // - 5..7: dudoso (pide checkbox)
  // - < 5: muy probablemente no
  const verdict =
    score >= 8 ? "likely" : score >= 5 ? "maybe" : "unlikely";

  return {
    text,
    strongHits,
    softHits,
    hasMoney,
    hasRUT,
    score,
    verdict,
  };
};

export async function runOCR(file) {
  // Lazy import para que tesseract no pese en el bundle inicial
  const { createWorker } = await import("tesseract.js");

  const worker = await createWorker("spa"); // español (si quieres, puedes usar "spa+eng")
  try {
    const { data } = await worker.recognize(file);
    const rawText = data?.text || "";
    return rawText;
  } finally {
    await worker.terminate();
  }
}
